export default __webpack_public_path__ + "static/shrimpocalypse-d7f57e849280de11584473fa3b91ca0a.webp";